export const Svg_112 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M32.813 45.281h4.375V30.99l5.833 6.198 3.136-3.136L35 22.822l-11.156 11.23 3.135 3.136 5.834-6.198V45.28ZM19.03 61.25c-1.166 0-2.187-.438-3.062-1.313-.875-.874-1.313-1.895-1.313-3.062V15.312h-2.99v-4.374h13.71V8.75h19.25v2.188h13.708v4.374h-2.99v41.563c0 1.167-.438 2.188-1.313 3.063-.874.874-1.895 1.312-3.062 1.312H19.031ZM50.97 15.312H19.031v41.563H50.97V15.312Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.459}
        x2={48.595}
        y1={16.625}
        y2={54.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)